import { Button } from '@mui/material';
import React, { useState,useContext } from 'react';
import { resetSelectedOptions, saveOrUpdateAnswerSelection } from '../Service/AssesmentResultService';
import { loadPopup } from '../Utils/LoginUtils';
import OptionsComponent from './OptionsComponent';
import { Store } from '../App';


export const Question = ({ questions, currQuestionIndex, setCurrQuestionIndex, finalResultJson, setFinalResultJson, currentQuestionObj, setCurrentQuestionObj, activeOption, setActiveOption, assesmentId, email, testSetId }) => {
    const [checkedObj, setCheckedObj] = useState([]);
    const {isCameraActivestore} = useContext(Store);
 

    const isResetDisabled = finalResultJson.length === 0 || finalResultJson.every(obj => !obj.qid === currentQuestionObj.qid);

    const handleCheckbox = (option, qid, qtype) => {

        // console.log(checkedObj);

        let obj = { assesmentId, email, testSetId, qid, quesType: qtype, selectedOption: option,cameraActive:isCameraActivestore};
        console.log("CHECKED HANDLE : ", obj);

        saveOrUpdateAnswerSelection(obj).then((response) => {
            if (isAssessmentInprogress(response.data)) {
                if (checkedObj.some(obj => obj && obj.qid === qid)) {
                    let temp = [...checkedObj];

                    for (let i = 0; i < temp.length; i++) {
                        if (temp[i].qid === qid) {
                            if (!temp[i].checkedOptions.some(op => op === option)) {
                                temp[i].checkedOptions.push(option);
                            } else {
                                temp[i].checkedOptions.splice(temp[i].checkedOptions.indexOf(option), 1);
                            }
                        }
                    }
                    // setCheckedObj(temp);
                    setCheckedObj((prev) => {
                        return [...temp]
                    })
                } else {
                    let result = {
                        assesmentId: assesmentId,
                        testSetId: testSetId,
                        email: email,
                        qid: qid,
                        checkedOptions: [option],
                        cameraActive:isCameraActivestore
                    };
                    // checkedObj.push(result);
                    setCheckedObj((prev) => {
                        return [...prev, result]
                    })

                }


                let checked = "";
                checkedObj.forEach(obj => {
                    if (obj.qid === qid) {
                        checked = obj.checkedOptions.toString();
                    }
                })

                if (finalResultJson.some(options => options.qid === qid)) {
                    let temp = [...finalResultJson];
                    temp.forEach(result => {
                        if (result.qid === qid) {
                            checkedObj.forEach(obj => {
                                if (obj.qid === result.qid) {
                                    result.selectedOption = obj.checkedOptions;
                                }
                            })
                        }
                        setFinalResultJson(temp);
                    })

                    //removing blank answer and respective question
                    setFinalResultJson(finalResultJson.filter(e => !(e.qid && e.selectedOption.length === 0)));
                } else {
                    const result = { assesmentId, testSetId, email, qid, selectedOption: option,cameraActive:isCameraActivestore };
                    setFinalResultJson(prevState => [...prevState, result])
                }
            }

        }).catch((err) => {
            console.log("Error catched while maq saveOrUpdateAnswerSelection", JSON.stringify(err));
            if (err.code === 'ERR_NETWORK' && err.response.status === null) {
                loadPopup('Server down, please send an email at - hr@voicera-analytics.com');
            } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 401) {
                loadPopup('Unauthorized!');
            } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 403) {
                loadPopup('Forbidden!');
            } else if (err.code === 'ERR_BAD_RESPONSE' || err.response.status === 500) {
                loadPopup('Ugh! Something went wrong.');
            } else {
                loadPopup(err.code + "-" + err.response.status);
            }
            // console.log("Error catched", err)
        });
    }

    const handleOptionSelect = (option, qid, qtype) => {
        const selectedOptionIndex = finalResultJson.findIndex(item => item.qid === qid);
        const selectedOption = selectedOptionIndex !== -1 ? finalResultJson[selectedOptionIndex].selectedOption : null;    

        if (selectedOption === option) {
            return; 
        }
        let obj = {};
        obj.assesmentId = assesmentId;
        obj.email = email;
        obj.testSetId = testSetId;
        obj.qid = qid;
        obj.quesType = qtype;
        obj.selectedOption = option;
        obj.cameraActive=isCameraActivestore;

        console.log("Option HANDLE : ", obj);
        saveOrUpdateAnswerSelection(obj).then((response) => {
            if (isAssessmentInprogress(response.data)) {
                if (finalResultJson.some(options => options.qid === qid)) {
                    let temp = [...finalResultJson];
                    temp.forEach(result => {
                        if (result.qid === qid) {
                            if (result.selectedOption === option) {
                                result.selectedOption = '';
                            } else {
                                result.selectedOption = option;
                            }
                        }
                        setFinalResultJson(temp);
                    })
                    setFinalResultJson(finalResultJson.filter(e => !(e.qid && e.selectedOption === '')));
                } else {
                    const result = { assesmentId, testSetId, email, qid, selectedOption: option };
                    setFinalResultJson(prevState => [...prevState, result])
                }
            }

        }).catch((err) => {
            console.log("Error catched while non maq saveOrUpdateAnswerSelection", err);
            if (err.code === 'ERR_NETWORK' && err.response.status === null) {
                loadPopup('Server down, please send an email at - hr@voicera-analytics.com');
            } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 401) {
                loadPopup('Unauthorized!');
            } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 403) {
                loadPopup('Forbidden!');
            } else if (err.code === 'ERR_BAD_RESPONSE' || err.response.status === 500) {
                loadPopup('Ugh! Something went wrong.');
            } else {
                loadPopup(err.code + "-" + err.response.status);
            }
            // console.log("Error catched", err)
        });

    }


    const nextQuestion = () => {
        currQuestionIndex < questions.length - 1 ? setCurrQuestionIndex(currQuestionIndex + 1) : setCurrQuestionIndex(currQuestionIndex);
        setCurrentQuestionObj(questions[currQuestionIndex + 1]);
    };

    const previousQuestion = () => {
        (currQuestionIndex > 0 && currQuestionIndex <= questions.length ? setCurrQuestionIndex(currQuestionIndex - 1) : setCurrQuestionIndex(currQuestionIndex));
        setCurrentQuestionObj(questions[currQuestionIndex - 1]);
    }

    const isAssessmentInprogress = (response) => {
        if (response === 'NO_DATA') {
            loadPopup('Test not found')
            return false;
        } else if (response === 'CANCELLED') {
            loadPopup('Test cancelled');
            return false;
        } else if (response === 'NOT_STARTED') {
            loadPopup('Please start the test first')
            return false;
        } else if (response === 'COMPLETED') {
            loadPopup('Test already completed');
            return false;
        } else if (response === 'EXPIRED') {
            loadPopup('Test expired');
            return false;
        } else if (response === 'BEFORE') {
            loadPopup('There is time to start the test');
            return false;
        } else if (response === 'N') {
            loadPopup('Something went wrong');
            return false;
        } else if (response === 'SUCCESS')
            return true;
    }

    const resetAnswer = (qid, finalResultJson) => {
        console.log("INSIDE RESET ANSWER");
        console.log(finalResultJson);
        if (finalResultJson.some(obj => obj.qid === qid)) {
            //========= Reset req to server Start ======================
            const resetQuestionRequest = { qid, assesmentId, testSetId, email };

            // console.log(resetQuestionRequest);
            resetSelectedOptions(resetQuestionRequest).then((response) => {
                if (isAssessmentInprogress(response.data)) {
                    //Reset the answer for the UI
                    let temp1 = [];
                    finalResultJson.filter(e => !(e.qid && e.qid === qid)).forEach(e => {
                        if (!(e.qid === qid)) {
                            temp1.push(e);
                        }
                    })
                    setFinalResultJson(temp1);

                    setCheckedObj(checkedObj.filter(e => !(e.qid && e.qid === qid)));
                    setFinalResultJson(temp1);
                } else {
                    // loadPopup('Reset failed');
                }

            }).catch((err) => {
                console.log("Error catched while resetting", err)
                if (err.code === 'ERR_NETWORK' && err.response.status === null) {
                    loadPopup('Server down, please send an email at - hr@voicera-analytics.com');
                } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 401) {
                    loadPopup('Unauthorized!');
                } else if (err.code === 'ERR_BAD_REQUEST' && err.response.status === 403) {
                    loadPopup('Forbidden!');
                } else if (err.code === 'ERR_BAD_RESPONSE' || err.response.status === 500) {
                    loadPopup('Ugh! Something went wrong.');
                } else {
                    loadPopup(err.code + "-" + err.response.status);
                }
            });
            //========= Reset req to server end ======================
        } else {
            console.log("Question un-attempted- can't reset");
        }
    }


    const isChecked = (qid, option) => {
        let flag = false;
        if (checkedObj.some(ob => ob.qid === qid)) {
            checkedObj.forEach(op => {
                let temp = op.checkedOptions;

                if (temp.some(x => (op.qid === qid && x === option))) {
                    flag = true;
                }
            })
        }
        return flag;
    }

    return (
        <div className='border rounded p-2 mt-3' style={{ width: '90%', height: 'auto' }}>
            <pre style={{ height: "auto", minHeight: "2rem", maxHeight: "", marginLeft: '1rem', fontSize: "16px", overflow: "auto" }}>
                {currentQuestionObj.questionStatement}
            </pre>
            <div style={{ display: 'flex', flexDirection: "column", width: "inherit" }}>
                {
                    Object.keys(currentQuestionObj).length > 0 && currentQuestionObj.options.map((option, index) => {
                        return <OptionsComponent key={index + Math.random()} option={option} index={index} currentQuestionObj={currentQuestionObj} handleCheckbox={handleCheckbox} isChecked={isChecked} activeOption={activeOption} handleOptionSelect={handleOptionSelect} finalResultJson={finalResultJson} />
                    })
                }

            </div>

            <div className='mt-2' style={{ display: 'flex', justifyContent: "space-between" }}>
                <Button onClick={previousQuestion} disabled={currQuestionIndex === 0}>Previous</Button>

                <Button className={isResetDisabled ? '' : 'text-danger'}
                    onClick={() => resetAnswer(currentQuestionObj.qid, finalResultJson)}
                    disabled={isResetDisabled}>
                    clear selection
                </Button>

                <Button onClick={nextQuestion} disabled={currQuestionIndex === questions.length - 1}>Next</Button>
            </div>
        </div>
    )
}
